import React, { useEffect } from "react";
import { InputCheck } from "../../../../controls";
import { useTranslation } from "react-i18next";
import { Collapse } from "@mui/material";

const StockTransferAccess = ({ setFeaturesAccess, featuresAccess }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!featuresAccess.id) {
      featuresAccess.isHaveStockTransferAccess
        ? setFeaturesAccess((j) => ({
            ...j,
            stockTransfer: {
              isHaveAddAccess: true,
              isHaveViewAccess: true,
              isHaveExportAccess: true,
              isHaveDeleteAccess: true,
            },
          }))
        : setFeaturesAccess((j) => ({
            ...j,
            stockTransfer: {
              isHaveAddAccess: false,
              isHaveViewAccess: false,
              isHaveExportAccess: false,
              isHaveDeleteAccess: false,
            },
          }));
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featuresAccess.isHaveStockTransferAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setFeaturesAccess((j) => ({
      ...j,
      stockTransfer: { ...j.stockTransfer, [name]: checked },
    }));
  };

  return (
    <Collapse in={featuresAccess.isHaveStockTransferAccess || false}>
      <div className="ml-25 d-grid g-5 mt-5">
        <InputCheck
          label={t("isHaveViewAccess")}
          checked={
            (featuresAccess.stockTransfer &&
              featuresAccess.stockTransfer.isHaveViewAccess) ||
            false
          }
          name={"isHaveViewAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveAddAccess")}
          checked={
            (featuresAccess.stockTransfer &&
              featuresAccess.stockTransfer.isHaveAddAccess) ||
            false
          }
          name={"isHaveAddAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveExportAccess")}
          checked={
            (featuresAccess.stockTransfer &&
              featuresAccess.stockTransfer.isHaveExportAccess) ||
            false
          }
          name={"isHaveExportAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveDeleteAccess")}
          checked={
            (featuresAccess.stockTransfer &&
              featuresAccess.stockTransfer.isHaveDeleteAccess) ||
            false
          }
          name={"isHaveDeleteAccess"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default StockTransferAccess;
